module.exports = __webpack_public_path__ + "img/LOGO.e8ae33be.png";